const AudienceLogin = () => import("../views/pages/audience/login/audience-login.vue"); // 登录页

// 页面框架
const AudienceHome = () => import("../views/pages/audience/audience-home.vue");
const AudienceHome1 = () => import("../views/pages/audience/audience-home1.vue");
const Home = () => import("../views/pages/audience/home/index.vue"); // 首页
const HomeMobile = () => import("../views/pages/audience/home-mobile/index.vue"); // 移动端申报
const success = () => import("../views/pages/audience/home-mobile-success/index.vue"); // 移动端申报
const BasicMobile = () => import("../views/pages/audience/basic-mobile/index.vue"); //移动端申报
const BasicMobileKf = () => import("../views/pages/audience/basic-mobile-kf/index.vue"); //移动端申报
const AudienceRouter = [
  {
    path: "/basic/mobile",
    name: "BasicMobile",
    component: BasicMobile,
  },
  {
    path: "/basic/kfmobile",
    name: "BasicMobileKf",
    component: BasicMobileKf,
  },
  {
    path: "/ExReg",
    name: "HomeMobile",
    component: HomeMobile,
  },
  {
    path: "/HomeMobile-success",
    name: "HomeMobile-success",
    component: success,
  },
  {
    path: "/",
    name: "AudienceHome",
    component: AudienceHome,
    children: [
      {
        // 首页
        path: "home",
        name: "home",
        component: Home,
      },

      {
        // 商机
        path: "chance",
        name: "chance",
        component: resolve => require(["@views/pages/audience/chance/index"], resolve),
      },
      {
        // 资讯
        path: "news",
        name: "news",
        component: resolve => require(["@views/pages/audience/news/index"], resolve),
      },
      {
        // 资讯
        path: "contact",
        name: "contact",
        component: resolve => require(["@views/pages/audience/contact/index"], resolve),
      },
      {
        // 线下会厅
        path: "meeting",
        name: "meeting",
        component: resolve => require(["@views/pages/audience/meeting/index"], resolve),
      },
      {
        // 线下会厅
        path: "meeting-live",
        name: "meeting-live",
        component: resolve => require(["@views/pages/audience/meeting-live/index"], resolve),
      },
      {
        // 关于
        path: "about",
        name: "about",
        component: resolve => require(["@views/pages/audience/about/index"], resolve),
      },
      {
        // 产品&展商列表
        path: "ex-list",
        name: "ex-list",
        component: resolve => require(["@views/pages/audience/ex-list/ex-list"], resolve),
      },
      {
        // 产品列表
        path: "pro-list",
        name: "pro-list",
        component: resolve => require(["@views/pages/audience/pro-list/pro-list"], resolve),
      },
      {
        // 活动列表
        path: "act-list",
        name: "act-list",
        component: resolve => require(["@views/pages/audience/act-list/act-list"], resolve),
      },
      {
        // 商机分类
        path: "chance-type",
        name: "chance-type",
        component: resolve => require(["@views/pages/audience/chance-type/index"], resolve),
      },
      {
        // 资讯详情
        path: "news-details",
        name: "news-details",
        component: resolve => require(["@views/pages/audience/news-details/index"], resolve),
      },
    ],
  },
  {
    // 商机详情
    path: "/chance-detail",
    name: "chance-detail",
    component: resolve => require(["@views/pages/audience/chance/chance-detail"], resolve),
  },
  {
    // 活动详情
    path: "/activity-details/:id",
    name: "activity-details",
    component: resolve => require(["@views/pages/audience/activity-details/activity-details"], resolve),
  },
  {
    // 产品详情
    path: "/pro-details/:id",
    name: "pro-details",
    component: resolve => require(["@views/pages/audience/pro-details/pro-details"], resolve),
  },
  {
    // 展商详情
    path: "/ex-details/:id",
    name: "ex-details",
    component: resolve => require(["@views/pages/audience/ex-details/ex-details"], resolve),
    meta: { allowBack: false },
  },
  //3D测试
  {
    path: "/three",
    name: "three",
    component: resolve => require(["@views/pages/audience/three/index"], resolve),
    meta: { allowBack: false },
  },
  // { path: '/chance', name: 'Chance', component: Chance },
  // {
  //     path: 'index', name: 'home', component: AudienceLayout, children: [
  //         { path: 'home', name: 'AudienceHome', component: AudienceHome },
  //         // {
  //         //     path: 'set', redirect: '/audience/index/set/base', name: 'set', component: set, children: [
  //         //         { path: 'base', name: 'base', component: audienceSet },
  //         //         { path: 'classify', name: 'classify', component: audienceSetClassify },
  //         //         { path: 'project', name: 'project', component: audienceSetProject },
  //         //     ]
  //         // },
  //     ],
  // },
  {
    path: "/login",
    redirect: "/login/alogin",
    name: "audience-register",
    component: AudienceLogin,
      children: [{ path: "alogin", name: "alogin", component: resolve => require(["@views/pages/audience/login/components/a-login"], resolve) },
          { path: "blogin", name: "blogin", component: resolve => require(["@views/pages/audience/login/components/b-login"], resolve) },
          { path: "register", name: "register", component: resolve => require(["@views/pages/audience/login/components/register"], resolve) },
          { path: "registerCmef", name: "registerCmef", component: resolve => require(["@views/pages/audience/login/components/registerCmef"], resolve) },
          { path: "reset-password", name: "reset-password", component: resolve => require(["@views/pages/audience/login/components/reset-password"], resolve) },
          { path: "reset-password2", name: "reset-password2", component: resolve => require(["@views/pages/audience/login/components/reset-password2"], resolve) },
          { path: "succeed", name: "succeed", component: resolve => require(["@views/pages/audience/login/components/succeed"], resolve) },
          { path: "succeed2", name: "succeed2", component: resolve => require(["@views/pages/audience/login/components/succeed2"], resolve) }],
  },
  {
    // 参展申请 - 登录
    path: "/join-login",
    name: "/join-login",
    component: resolve => require(["@views/pages/audience/joinEx/subpages/login"], resolve),
  },
  {
    path: "/",
    name: "AudienceHome1",
    component: AudienceHome1,
    children: [
      {
        // 首页
        path: "home",
        name: "home",
        component: Home,
      },
      {
        // 参展申请
        path: "join",
        name: "join",
        component: resolve => require(["@views/pages/audience/joinEx/index"], resolve),
        redirect: "/join/basic",
        children: [
          {
            // 基本信息
            path: "basic",
            name: "basic",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/basic"], resolve),
          },
          {
            // 选择入口
            path: "entrance",
            name: "entrance",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/entrance"], resolve),
          },
          {
            // 选择订单
            path: "order",
            name: "order",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/order"], resolve),
          },
          {
            // 会刊信息
            path: "catalogue",
            name: "catalogue",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/catalogue"], resolve),
          },
          {
            // 报名表
            path: "application",
            name: "application",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/application"], resolve),
          },
          {
            // 完成
            path: "finish",
            name: "finish",
            component: resolve => require(["@views/pages/audience/joinEx/subpages/finish"], resolve),
          },
        ],
      },
      {
        // 展团参展申请
        path: "join/pavilion",
        name: "join/pavilion",
        component: resolve => require(["@views/pages/audience/Pavilion/index"], resolve),
        redirect: "/join/pavilion/basic",
        children: [
          {
            // 基本信息
            path: "basic",
            name: "basic",
            component: resolve => require(["@views/pages/audience/Pavilion/subpages/basic"], resolve),
          },
          // { // 选择入口
          //   path: 'entrance',
          //   name: 'entrance',
          //   component: (resolve) => require(['@views/pages/audience/joinEx/subpages/entrance'], resolve)
          // },
          {
            // 选择订单
            path: "order",
            name: "order",
            component: resolve => require(["@views/pages/audience/Pavilion/subpages/order"], resolve),
          },
          {
            // 会刊信息
            path: "catalogue",
            name: "catalogue",
            component: resolve => require(["@views/pages/audience/Pavilion/subpages/catalogue"], resolve),
          },
          {
            // 报名表
            path: "application",
            name: "application",
            component: resolve => require(["@views/pages/audience/Pavilion/subpages/application"], resolve),
          },
          {
            // 完成
            path: "finish",
            name: "finish",
            component: resolve => require(["@views/pages/audience/Pavilion/subpages/finish"], resolve),
          },
        ],
      },
    ],
  },
];

export { AudienceRouter };
